/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { DialogPopup, DialogPopupType } from '@/components/ui/DialogPopup';
import { createFileRoute } from '@tanstack/react-router'

type ErrorParams = {
    title: string|undefined,
    message: string|null,
    no_buttons: boolean|undefined,
    redirect_url: string|undefined,
    auto_ok_delay: number|undefined
}

export const Route = createFileRoute('/error')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>):ErrorParams => {
    var auto_ok_delay = -1;
    if(search.auto_ok_delay !== undefined){
        auto_ok_delay = parseInt(search.auto_ok_delay as string);
    }
    return {
        title: search.title as string|undefined,
        message: search.message !== undefined ? search.message as string : null,
        no_buttons: search.no_buttons as boolean|undefined,
        redirect_url: search.redirect_url as string|undefined,
        auto_ok_delay: auto_ok_delay
    }
  }
})

function RouteComponent() {
    const {title, message, no_buttons, redirect_url, auto_ok_delay} = Route.useSearch();

    return <div><DialogPopup
        title={title}
        message={message ? message : ""}
        type={no_buttons ? DialogPopupType.NoButtons : DialogPopupType.CloseOnly}
        redirect_url={redirect_url}
        auto_ok_delay={auto_ok_delay}
    /></div>
}
